/**
 * Configuration for buyer, seller, service, and tax fees.
 * This structure mirrors the Laravel config/fees.php file.
 */
export const feeConfig = {
  // --- Buyer Fees (Tiered Structure) ---
  buyer: [
    { min: 0, max: 99, fee: 40 },
    { min: 100, max: 199, fee: 75 },
    { min: 200, max: 299, fee: 120 },
    { min: 300, max: 499, fee: 140 },
    { min: 500, max: 699, fee: 180 },
    { min: 700, max: 899, fee: 210 },
    { min: 900, max: 999, fee: 285 },
    { min: 1000, max: 1199, fee: 320 },
    { min: 1200, max: 1299, fee: 350 },
    { min: 1300, max: 1399, fee: 385 },
    { min: 1400, max: 1499, fee: 445 },
    { min: 1500, max: 1999, fee: 485 },
    { min: 2000, max: 2499, fee: 510 },
    { min: 2500, max: 2999, fee: 535 },
    { min: 3000, max: 3499, fee: 570 },
    { min: 3500, max: 3999, fee: 610 },
    { min: 4000, max: 4499, fee: 655 },
    { min: 4500, max: 4999, fee: 705 },
    { min: 5000, max: 5499, fee: 725 },
    { min: 5500, max: 5999, fee: 780 },
    { min: 6000, max: 6499, fee: 805 },
    { min: 6500, max: 6999, fee: 825 },
    { min: 7000, max: 7499, fee: 845 },
    { min: 7500, max: 7999, fee: 885 },
    { min: 8000, max: 8499, fee: 905 },
    { min: 8500, max: 9999, fee: 980 },
    { min: 10000, max: 14999, fee: 1000 },
    // Note: 'max' is intentionally null to denote no upper limit
    { min: 15000, max: null, fee_percent: 7 },
  ],

  // --- Seller Fees (Tiered Structure) ---
  seller: [
    { min: 0, max: 99, fee: 40 },
    { min: 100, max: 199, fee: 55 },
    { min: 200, max: 299, fee: 100 },
    { min: 300, max: 499, fee: 120 },
    { min: 500, max: 699, fee: 150 },
    { min: 700, max: 899, fee: 190 },
    { min: 900, max: 999, fee: 255 },
    { min: 1000, max: 1199, fee: 280 },
    { min: 1200, max: 1299, fee: 300 },
    { min: 1300, max: 1399, fee: 380 },
    { min: 1400, max: 1499, fee: 400 },
    { min: 1500, max: 1999, fee: 450 },
    { min: 2000, max: 2499, fee: 480 },
    { min: 2500, max: 2999, fee: 500 },
    { min: 3000, max: 3499, fee: 550 },
    { min: 3500, max: 3999, fee: 580 },
    { min: 4000, max: 4499, fee: 600 },
    { min: 4500, max: 4999, fee: 650 },
    { min: 5000, max: 5499, fee: 680 },
    { min: 5500, max: 5999, fee: 705 },
    { min: 6000, max: 6499, fee: 780 },
    { min: 6500, max: 6999, fee: 800 },
    { min: 7000, max: 7499, fee: 805 },
    { min: 7500, max: 7999, fee: 850 },
    { min: 8000, max: 8499, fee: 900 },
    { min: 8500, max: 9999, fee: 950 },
    { min: 10000, max: 14999, fee: 970 },
    { min: 15000, max: null, fee_percent: 5 },
  ],

  // --- Fixed Fees ---
  service_fee: 98,
  tax_rate: 13, // Tax rate in percent (13%)
};